// Figma: "Log In" page, shared "Main Content" + page background across every login state
// (node 18050:151 and siblings). Full-height neutral-50 background, content centered.
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Stack} from '@mui/material';
import {tokens} from '../../../themes/ThemeCustomization';
import AuthFooter from './AuthFooter';

const AuthShell = ({children}) => (
    <Box sx={{minHeight: '100vh', backgroundColor: tokens.color.neutral50, display: 'flex', flexDirection: 'column'}}>
        <Stack sx={{flex: 1, alignItems: 'center', justifyContent: 'center', width: '100%', py: 5}}>
            <Box sx={{width: '100%', maxWidth: '480px', px: 2}}>{children}</Box>
        </Stack>
        <AuthFooter />
    </Box>
);

AuthShell.propTypes = {
    children: PropTypes.node
};

export default AuthShell;
